export default {"src":"/polygon/_next/static/media/beefy.159cec96.svg","height":48,"width":48};